import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  border: "1px solid white",
  transition: "background-color 0.3s ease",
}));

export default function DAMP_OCU_RELOJ_ARENA({
  exercise, isRunning, velocity
}) {
  const [currentLine, setCurrentLine] = useState(0);
  const [rows, setRows] = useState(exercise.lineas)
  const [text, setText] = useState(exercise.content)
  const [size, setSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  //const [velocidad, setVelocidad] = useState(null)
  const velocidad = useRef(null)

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setSize({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight,
        });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    let interval = null
    console.log(velocidad.current)
    if (isRunning) {
      interval = setInterval(() => {
        setCurrentLine((prev) => (prev + 1) % rows);
      }, velocidad.current);
    }

    return () => { if (interval) clearInterval(interval)};
  }, [rows, isRunning, velocidad.current]);

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = '14px Arial, sans-serif';
      canvasRef.current = canvas;
    }
  }, []);

  const measureText = (text: string): number => {
    if (canvasRef.current) {
      const context = canvasRef.current.getContext('2d');
      if (context) {
        return context.measureText(text).width;
      }
    }
    return 0;
  };

  const createHourglassLines = () => {
    const words = text.split(/\s+/);
    const lines: string[] = new Array(rows).fill("");
    const middleRow = Math.floor(rows / 2);
    let wordIndex = 0;
    let remainingWords = "";
    let numPalabras = 0

    for (let i = 0; i < rows; i++) {
      const lineCapacity = i <= middleRow ? rows - i : i + 1;
      const maxWidth = size.width * (lineCapacity / rows) * 0.7; // 90% of the available width

      let lineWords = remainingWords ? [remainingWords] : [];
      let currentLineWidth = measureText(remainingWords);
      remainingWords = "";

      while (wordIndex < words.length) {
        const word = words[wordIndex];
        const wordWidth = measureText(word);
        const spaceWidth = measureText(" ");

        if (currentLineWidth + wordWidth + (lineWords.length > 0 ? spaceWidth : 0) <= maxWidth) {
          lineWords.push(word);
          numPalabras += 1
          currentLineWidth += wordWidth + (lineWords.length > 1 ? spaceWidth : 0);
          wordIndex++;
        } else {
          remainingWords = word;
          break;
        }
      }

      lines[i] = lineWords.join(" ");

      if (wordIndex >= words.length && !remainingWords) {
        wordIndex = 0;
        remainingWords = "";
      }
    }
    console.log(lines)
    let velocidadTemp = ((1000 / velocity) * 60);
    console.log(lines.join(" ").split("").length)
    velocidadTemp = velocidadTemp * (numPalabras / exercise.lineas);
    velocidad.current = velocidadTemp
    return lines;
  };

  const lines = createHourglassLines();
  

  const getLineWidth = (index: number) => {
    const middleRow = Math.floor(rows / 2);
    return `${
      Math.pow((index <= middleRow ? rows - index : index + 1) / rows, 1.2) *
      100
    }%`;
  };

  return (
    <Box
      sx={{
        p: 0,
        alignItems: "center",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        background: "#ffffff",
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingRight: 5,
      }}
    >
      <Box
        ref={containerRef}
        sx={{
          width: "100%",
          height: "100%",
          minHeight: isMobile ? "75vh" : "100%",
          overflow: "hidden",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {lines.map((line, index) => (
          <StyledPaper
            key={index}
            elevation={0}
            sx={{
              width: getLineWidth(index),
              height: `${100 / rows}%`,
              margin: "auto",
              overflow: "hidden",
              backgroundColor:
                index === currentLine ? "#BFDBFE" : "transparent",
            }}
          >
            <Typography
              variant="body2"
              align="center"
              sx={{
                fontSize: {
                  xs: `calc(0.6rem + ${0.8 / rows}vw + ${0.8 / rows}vh)`,
                  sm: `calc(0.7rem + ${1 / rows}vw + ${1 / rows}vh)`,
                  md: `calc(0.8rem + ${1.1 / rows}vw + ${1.1 / rows}vh)`,
                  lg: `calc(0.9rem + ${1.2 / rows}vw + ${1.2 / rows}vh)`,
                },
                fontFamily: "Arial, sans-serif",
                userSelect: "none",
                width: "100%",
               
                overflow: "hidden",
                whiteSpace: "collapse",
              }}
            >
              {line}
            </Typography>
          </StyledPaper>
        ))}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            height: "100%",
            width: "1px",
            backgroundColor: "#666",
            transform: "translateX(-50%)",
          }}
        />
      </Box>
    </Box>
  );
}

